const mainCategories = [
  {
    title: '產業 AI 化',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E7%94%A2%E6%A5%ADAI%E5%8C%96',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E7%94%A2%E6%A5%ADAI%E5%8C%96',
  },
  {
    title: '新技術揭密',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%96%B0%E6%8A%80%E8%A1%93%E6%8F%AD%E5%AF%86',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%96%B0%E6%8A%80%E8%A1%93%E6%8F%AD%E5%AF%86',
  },
  {
    title: '新創分析',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%96%B0%E5%89%B5%E5%88%86%E6%9E%90',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=%E6%96%B0%E5%89%B5%E5%88%86%E6%9E%90',
  },
  {
    title: 'AI 環境',
    subtitle1: '焦點',
    href1: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=AI%E7%92%B0%E5%A2%83',
    subtitle2: '簡報',
    href2: 'https://ieknet.iek.org.tw/iekrpt/Default.aspx?tagStr=AI%E7%92%B0%E5%A2%83',
  },
]
export default mainCategories;